module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-zen-1.737f3323.png";